export const IconLinkedin = () => (
  <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M21.7466 19.6873C21.7466 21.1714 20.4602 22.3746 18.8733 22.3746C17.2864 22.3746 16 21.1714 16 19.6873C16 18.2031 17.2864 17 18.8733 17C20.4602 17 21.7466 18.2031 21.7466 19.6873Z"
      fill="white"
    />
    <path d="M16.3929 24.3498H21.3045V39.2332H16.3929V24.3498Z" fill="white" />
    <path
      d="M29.2122 24.3498H24.3006V39.2332H29.2122C29.2122 39.2332 29.2122 34.5477 29.2122 31.6181C29.2122 29.8597 29.8126 28.0936 32.2083 28.0936C34.9157 28.0936 34.8994 30.3948 34.8868 32.1775C34.8703 34.5078 34.9097 36.8858 34.9097 39.2332H39.8213V31.3781C39.7797 26.3624 38.4728 24.0512 34.173 24.0512C31.6195 24.0512 30.0367 25.2105 29.2122 26.2593V24.3498Z"
      fill="white"
    />
  </svg>
);
